import { AfterViewInit, Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder, NgForm } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import { CustomValidators } from '../../directives/custom-validator.directive';
import { ToastrService } from 'ngx-toastr';
import { logbaseService } from "../../services/logbase.service";
import { formDialogService } from '../../services/formDialogService';
import { NewPackageService } from '../../services/NewPackage.service';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Router, ActivatedRoute } from '@angular/router';
import { packageLookup } from '../../models/packageLookup';
import { Observable ,  Subject } from 'rxjs';
import { Table } from 'primeng/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { TranslateService } from '@ngx-translate/core';
//import { timingSafeEqual } from 'crypto';

@Component({
  selector: 'app-new-package',
  templateUrl: './new-package.component.html',
  styleUrls: ['./new-package.component.scss']
})
export class NewPackageComponent implements OnInit {
  fusoPkgLookup: any;
  approvedPkgLookup: any;
  chkFusoPkgCode: any;
  checkPkgCode: any;
  pkgDetailsDataAdmin: any;
  pkgDetailsAdminData: any;
  fusoPkgDetailsData: any;
  pkgDetailsData: any;
  pkgDetailAdminFuso: any;
  addAdminComment: boolean;
  pkgDetailAdmin: any;
  adminCommentDialogue: boolean;
  folVol: any;
  showFoldableError: boolean;
  foldableResult: number;
  externalResult: number;
  newSuppCode: any;
  foldableGreater: any;
  createdBySM: any;
  sub: any;
  pkgcodeCheckFuso: any;
  ExtWidth: number;
  ExtLength: number;
  ExtHeight: number;
  InnWidth: number;
  InnLength: number;
  InnHeight: number;
  heightGreater: boolean;
  widthGreater: boolean;
  display: boolean = false;
  statusDisplay: boolean = false;
  lengthGreater: boolean;
  approvedPkg: any;
  changeStatusTo: string;
  showStatusComment: boolean;
  statusOption: any;
  createdBySuppCode: any;
  rejectionComment: any;
  fusoStatus: string;
  fusoPkgComment: any;
  fusoPkgCodeStatus: any;
  fusoPkgDetails: any;
  fusoPkgInfo: any;
  suppCode: any;
  suppCodeArry: any[];
  firstSupplierCode: any;
  userSuppCode: any;
  loginId: any;
  userRoleID: any;
  pkgStatus: any;
  pkgCodeComment: any;
  pkgInfoResult: any;
  pkgDetail: any;
  status: any;
  @Input() openRequested: boolean;
  @Input() pkgIdCreated: any;
  @Input() fusoPkgIdCreated: any;
  @Input() openfusoRequested: any
  @Input() pkgData: any;
  @Input() adminEdit: boolean;
  @Input() pkgFusoData: any;
  @Input() admitFusoEdit: boolean;
  @Output() closeModalPopup: EventEmitter<any> = new EventEmitter<any>();
  @Output() setModalStyle: EventEmitter<any> = new EventEmitter<any>();
  @Output() openModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() createFuso: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeAdmitEdit: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeAdminFusoEdit: EventEmitter<any> = new EventEmitter<any>();
  pkgCodeStatus: any;
  pkgCommentError: boolean;
  pkgComment: any;
  afterSaveNavigate: boolean = true;
  InnVol: any;
  extVol: any;
  codeFlag: boolean;
  pkgcodeCheck: any;
  PackageCode: any;
  newPackageForm: FormGroup;
  specialPackageOpt: string[] = ["Yes(はい)", "No(いいえ)"];
  standardPackageOpt: string[] = ["Yes(はい)", "No(いいえ)"];
  containerTypeOpt: string[] = ["GLT", "KLT"];
  containerTypeBind: string = '';
  packageMaterialOpt: string[] = ["Plastic", "Steel", "Iron", "Carton Box"];
  foldableOptions: string[] = ['Yes(はい)', 'No(いいえ)', 'N/A'];
  model = { isFoldable: 'No' };
  innerPackH: any;
  innerPackL: any;
  innerPackW: any;
  externalPackH: any;
  externalPackL: any;
  externalPackW: any;
  foldableH: number;
  foldableL: number;
  foldableW: number;
  loadCapacity: any;
  tareWeight: any;
  totalPackageWeight: any;
  packageId: any;
  modalRef: NgbModalRef;
  // pkgCodePattern: any = "[A-Z]{2}[-]{1}[0-9]{3}";
  blockSpace: RegExp = /[^\s]/;
  packageLookup: packageLookup[];
  filter: packageLookup = new packageLookup();
  public visible = false;
  public visibleAnimate = false;
  @ViewChild(Table) dataTableComponent: Table;
  columns: any[];
  extractedPart: string | null = null;


  constructor(private form: FormBuilder, private formDialogService: formDialogService, public activeModal: NgbActiveModal,
    private newPackageService: NewPackageService, private toaster: ToastrService, private modalService: NgbModal, private router: Router,
    private spinner: NgxSpinnerService, private route: ActivatedRoute, private translate: TranslateService) {

  
  }

  ngOnInit() {
    this.checkForNewSMPackage();
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
    this.loginId = userDetJson.loginId;
    this.userSuppCode = userDetJson.supplierCode;
    if (this.userSuppCode != null) {
      this.suppCode = this.userSuppCode.toString();
      this.suppCodeArry = userDetJson.supplierCode;
      if (this.suppCodeArry != null && this.suppCodeArry.length > 1) {
        this.firstSupplierCode = this.suppCodeArry[0];
      }
    }
    if (this.openRequested == true) {
      this.newPackageService.checkPackageCodeAvailiblity(this.pkgIdCreated).subscribe(result => {
        this.pkgDetailsData = result;
        this.pkgDetail = this.pkgDetailsData.response;
        this.pkgCodeStatus = this.pkgDetailsData.packageCodeStatus;
        this.pkgCodeComment = this.pkgDetailsData.supplierComment;
        this.rejectionComment = this.pkgDetailsData.logisticsComment;
        this.createdBySuppCode = this.pkgDetailsData.supplierCode
      });
      this.getPackgageCodeById(this.pkgIdCreated);
    }
    if (this.openfusoRequested == true) {
      this.newPackageService.getFusoPackageCodeById(this.fusoPkgIdCreated).subscribe(result => {
        this.fusoPkgDetailsData = result
        this.fusoPkgDetails = this.fusoPkgDetailsData.response;
        this.fusoPkgCodeStatus = this.fusoPkgDetailsData.newPackageCodeStatus;
        this.fusoPkgComment = this.fusoPkgDetailsData.comment;
      })
      this.getFusoPackageById(this.fusoPkgIdCreated);
    }

    if (this.adminEdit == true) {
      this.getPackgageCodeById(this.pkgData);
      this.newPackageService.checkPackageCodeAvailiblity(this.pkgData).subscribe(result => {
        this.pkgDetailsAdminData = result;
        this.pkgDetailAdmin = this.pkgDetailsAdminData.createBy;

      });
    }
    if (this.admitFusoEdit == true) {
      this.getFusoPackageById(this.pkgFusoData);
      this.newPackageService.getFusoPackageCodeById(this.pkgFusoData).subscribe(result => {
        this.pkgDetailsDataAdmin = result;
        this.pkgDetailAdmin = this.pkgDetailsDataAdmin.createBy;

      });
    }
    this.createFormControls();
    this.newPackageForm.valueChanges.subscribe(val => { }
    );
    this.getAllApprovedPkgCode();
    this.foldableDisabled();
    this.dataTableComponent.reset();
    // this.route.data.subscribe(v =>{
    //   this.createdBySM = v.SMcreated != null ? !!v.SMcreated : false})
    if (this.newPackageForm.get('isFoldable').value == 'No') {
      this.foldableGreater = false;
    }
    else {
      this.foldableGreater = true;
    }

  }
  checkForNewSMPackage() {
    const currentUrl = this.router.url; 
    console.log(currentUrl); 


    const pathParts = currentUrl.split('/'); 
    const lastSegment = pathParts[pathParts.length - 1]; 

    if (lastSegment === 'newSMPackage') {
      this.extractedPart = lastSegment;
      this.createdBySM = true 
    }
    else{
      this.createdBySM=false
    }
  }


  createFormControls() {
    this.newPackageForm = new FormGroup({
      packageCode: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(14)]),
      totalMaxWeightBox: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(5), CustomValidators.isNum]),
      standardPackaging: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, Validators.required),
      packagingName: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(14)]),
      specializedPackaging: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, Validators.required),
      innerPackDimW: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(3), CustomValidators.isNum]),
      innerPackDimL: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(3), CustomValidators.isNum]),
      innerPackDimH: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(3), CustomValidators.isNum]),
      innerVolume: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(7), CustomValidators.isNum]),
      externalPackDimW: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(3), CustomValidators.isNum]),
      externalPackDimL: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(3), CustomValidators.isNum]),
      externalPackDimH: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(3), CustomValidators.isNum]),
      externalCubicMeter: new FormControl({ value: '', disabled: true }, [Validators.required, CustomValidators.isNum, Validators.maxLength(7)]),
      isFoldable: new FormControl({ value: 'No', disabled: this.openRequested == true || this.openfusoRequested }, Validators.required),
      foldablePackDimW: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(2), CustomValidators.isNum]),
      foldablePackDimL: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(2), CustomValidators.isNum]),
      foldablePackDimH: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(6), Validators.minLength(2), CustomValidators.isNum]),
      foldableVolume: new FormControl({ value: '', disabled: true }, [Validators.required, CustomValidators.isNum, Validators.maxLength(7)]),
      permittedLoadCapacity: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(5), CustomValidators.isNum, CustomValidators.isNegative]),
      packageMaterial: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(15)]),
      packageTareWeight: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.required, Validators.maxLength(5), CustomValidators.isNum]),
      totalPackageWeight: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested }, [Validators.maxLength(10), CustomValidators.isNum]),
      containerType: new FormControl({ value: '', disabled: this.openRequested == true || this.openfusoRequested })
    });
  }

  getValidatorForContainer() {
    if (this.containerTypeBind == 'KLT') {
      return Validators.max(15);
    }
    else
      return '';
  }

  submitNewPackageForm() {
    if (this.pkgComment != '' && this.pkgComment != null) {
      var newPackageDataToSend = {
        packageCode: this.newPackageForm.get('packageCode').value,
        fusoPackageCode: this.newPackageForm.get('packageCode').value,
        standardPackaging: this.newPackageForm.get('standardPackaging').value,
        specializedPackaging: this.newPackageForm.get('specializedPackaging').value,
        packagingName: this.newPackageForm.get('packagingName').value,
        totalMaxWeightBox: this.newPackageForm.get('totalMaxWeightBox').value,
        innerPackDimW: this.newPackageForm.get('innerPackDimW').value,
        innerPackDimL: this.newPackageForm.get('innerPackDimL').value,
        innerPackDimH: this.newPackageForm.get('innerPackDimH').value,
        innerVolume: this.newPackageForm.get('innerVolume').value,
        externalPackDimW: this.newPackageForm.get('externalPackDimW').value,
        externalPackDimL: this.newPackageForm.get('externalPackDimL').value,
        externalPackDimH: this.newPackageForm.get('externalPackDimH').value,
        externalCubicMeter: this.newPackageForm.get('externalCubicMeter').value,
        isFoldable: this.newPackageForm.get('isFoldable').value,
        foldablePackDimW: this.newPackageForm.get('foldablePackDimW').value,
        foldablePackDimL: this.newPackageForm.get('foldablePackDimL').value,
        foldablePackDimH: this.newPackageForm.get('foldablePackDimH').value,
        foldableVolume: this.newPackageForm.get('foldableVolume').value,
        permittedLoadCapacity: this.newPackageForm.get('permittedLoadCapacity').value,
        packageTareWeight: this.newPackageForm.get('packageTareWeight').value,
        packageMaterial: this.newPackageForm.get('packageMaterial').value,
        containerType: this.newPackageForm.get('containerType').value,
        repackagingLocation: null,
        packagingProperty: null,
        image1: null,
        // packageCodeStatus: 'new',
        packageCodeStatus: 'approved',
        newPackageCodeStatus: 'approved',
        comment: this.pkgComment,
        supplierComment: this.pkgComment,
        supplierCode: (this.suppCodeArry != null && this.suppCodeArry.length > 1) ? this.suppCodeArry[0].toString() : this.suppCode,
      };
      Object.assign(newPackageDataToSend, this.adminEdit || this.admitFusoEdit ? { updatedBy: this.loginId } : null);
      Object.assign(newPackageDataToSend, this.adminEdit || this.admitFusoEdit ? { createBy: this.pkgDetailAdmin } : { createBy: this.loginId });
      // Object.assign(newPackageDataToSend, this.admitEdit  ? { packageCodeStatus: 'approved' } : { packageCodeStatus: 'new' });

      if (this.userRoleID == 1) {
        this.newPackageService.submitNewPackageData(newPackageDataToSend)
          .subscribe(response => {
            this.router.navigate(['/packageDashboard/package']);
            this.closeAdmitEdit.emit()
          });
      }
      else if ((this.userRoleID == 5 || this.userRoleID == 9) && this.adminEdit) {
        this.newPackageService.submitNewPackageData(newPackageDataToSend)
          .subscribe(response => {
            this.router.navigate(['/packageDashboard/package']);
            this.closeAdmitEdit.emit()
          });
      }
      else if (this.userRoleID == 2 || this.userRoleID == 3 || this.userRoleID == 4 || this.userRoleID == 7) {
        this.newPackageService.submitFusoPackageData(newPackageDataToSend)
          .subscribe(response => {
            this.router.navigate(['/packageDashboard/package']);
            this.createFuso.emit();
          })
      }
      else if ((this.userRoleID == 5 || this.userRoleID == 9) && this.admitFusoEdit) {
        this.newPackageService.submitFusoPackageData(newPackageDataToSend)
          .subscribe(response => {
            this.router.navigate(['/packageDashboard/package']);
            this.closeAdminFusoEdit.emit();
          })
      }
      this.translate.get('CreatedSuccessfully').subscribe((res: string) => {
        this.toaster.success(this.packageId + '  ' + res);
      });
      // this.toaster.success(this.packageId + ' ' + 'has been created Successfully!');
      this.afterSaveNavigate = false;
      this.modalRef.close();
      this.pkgCommentError = false;
    }
    else {
      this.pkgCommentError = true;
    }
  }


  submitSMNewPackage() {
    if (this.pkgComment != '' && this.pkgComment != null) {
      var newPackageDataToSend = {
        packageCode: this.newPackageForm.get('packageCode').value,
        fusoPackageCode: this.newPackageForm.get('packageCode').value,
        standardPackaging: this.newPackageForm.get('standardPackaging').value,
        specializedPackaging: this.newPackageForm.get('specializedPackaging').value,
        packagingName: this.newPackageForm.get('packagingName').value,
        totalMaxWeightBox: this.newPackageForm.get('totalMaxWeightBox').value,
        innerPackDimW: this.newPackageForm.get('innerPackDimW').value,
        innerPackDimL: this.newPackageForm.get('innerPackDimL').value,
        innerPackDimH: this.newPackageForm.get('innerPackDimH').value,
        innerVolume: this.newPackageForm.get('innerVolume').value,
        externalPackDimW: this.newPackageForm.get('externalPackDimW').value,
        externalPackDimL: this.newPackageForm.get('externalPackDimL').value,
        externalPackDimH: this.newPackageForm.get('externalPackDimH').value,
        externalCubicMeter: this.newPackageForm.get('externalCubicMeter').value,
        isFoldable: this.newPackageForm.get('isFoldable').value,
        foldablePackDimW: this.newPackageForm.get('foldablePackDimW').value,
        foldablePackDimL: this.newPackageForm.get('foldablePackDimL').value,
        foldablePackDimH: this.newPackageForm.get('foldablePackDimH').value,
        foldableVolume: this.newPackageForm.get('foldableVolume').value,
        permittedLoadCapacity: this.newPackageForm.get('permittedLoadCapacity').value,
        packageTareWeight: this.newPackageForm.get('packageTareWeight').value,
        packageMaterial: this.newPackageForm.get('packageMaterial').value,
        containerType: this.newPackageForm.get('containerType').value,
        repackagingLocation: null,
        packagingProperty: null,
        image1: null,
        packageCodeStatus: 'approved',
        // comment: this.pkgComment,
        supplierComment: this.pkgComment,
        supplierCode: this.suppCode,
        createBy: this.loginId
      };
      this.newPackageService.submitNewPackageData(newPackageDataToSend)
        .subscribe(response => {
          this.router.navigate(['/packageDashboard/package']);
        });
      this.translate.get('CreatedSuccessfully').subscribe((res: string) => {
        this.toaster.success(this.packageId + '  ' + res);
      });
      // this.toaster.success(this.packageId + ' ' + 'has been created Successfully!');
      this.afterSaveNavigate = false;
      this.modalRef.close();
      this.pkgCommentError = false;
    }
  }

  updatePkgStatus() {
    if (this.statusOption == 1) {
      this.changeStatusTo = 'approved';
      var updatedStatusData = {
        comments: this.pkgComment,
        packStatus: this.changeStatusTo,
        packageCode: this.pkgIdCreated,
        updatedBy: this.loginId,
        userRole: this.userRoleID
      }

      this.newPackageService.updatePkgStatus(updatedStatusData).subscribe(
        result => {
          this.closeModalPopup.emit();
          this.toaster.success("Package " + this.changeStatusTo + " successfully!");
        })
    } else if (this.statusOption == 2) {
      this.changeStatusTo = 'rejected';
      if (this.pkgComment == '' || this.pkgComment == null) {
        this.pkgCommentError = true;
      } else {
        this.pkgCommentError = false;
        var updatedStatusData = {
          comments: this.pkgComment,
          packStatus: this.changeStatusTo,
          packageCode: this.pkgIdCreated,
          updatedBy: this.loginId,
          userRole: this.userRoleID
        }
        this.newPackageService.updatePkgStatus(updatedStatusData).subscribe(
          result => {
            this.closeModalPopup.emit();
            this.toaster.success("Package " + this.changeStatusTo + " successfully!");
          }
        )
      }
    }
  }

  onCommentEnter() {
    if (this.pkgComment == '') {
      this.pkgCommentError = true;
    } else {
      this.pkgCommentError = false;
    }
  }

  getPackgageCodeById(id) {
    this.spinner.show();
    this.newPackageService.checkPackageCodeAvailiblity(id).subscribe(result => {
      this.pkgInfoResult = result;
      this.newPackageForm.patchValue({
        packageCode: this.pkgInfoResult.response.packageCode,
        standardPackaging: this.pkgInfoResult.response.standardPackaging,
        specializedPackaging: this.pkgInfoResult.response.specializedPackaging,
        packagingName: this.pkgInfoResult.response.packagingName,
        totalMaxWeightBox: this.pkgInfoResult.response.totalMaxWeightBox,
        innerPackDimW: this.pkgInfoResult.response.innerPackDimW,
        innerPackDimL: this.pkgInfoResult.response.innerPackDimL,
        innerPackDimH: this.pkgInfoResult.response.innerPackDimH,
        innerVolume: this.pkgInfoResult.response.innerVolume,
        externalPackDimW: this.pkgInfoResult.response.externalPackDimW,
        externalPackDimL: this.pkgInfoResult.response.externalPackDimL,
        externalPackDimH: this.pkgInfoResult.response.externalPackDimH,
        externalCubicMeter: this.pkgInfoResult.response.externalCubicMeter,
        isFoldable: this.pkgInfoResult.response.isFoldable,
        foldablePackDimW: this.pkgInfoResult.response.foldablePackDimW,
        foldablePackDimL: this.pkgInfoResult.response.foldablePackDimL,
        foldablePackDimH: this.pkgInfoResult.response.foldablePackDimH,
        foldableVolume: this.pkgInfoResult.response.foldableVolume,
        permittedLoadCapacity: this.pkgInfoResult.response.permittedLoadCapacity,
        packageTareWeight: this.pkgInfoResult.response.packageTareWeight,
        packageMaterial: this.pkgInfoResult.response.packageMaterial,
        containerType: this.pkgInfoResult.response.containerType
      });
      this.spinner.hide();
      if (this.adminEdit == true) {
        this.newPackageForm.controls['packageCode'].disable();
      }
      if (this.pkgInfoResult.response.isFoldable == 'Yes') {
        this.newPackageForm.controls['foldablePackDimW'].enable();
        this.newPackageForm.controls['foldablePackDimL'].enable();
        this.newPackageForm.controls['foldablePackDimH'].enable();
      }
    });
  }

  getFusoPackageById(id) {
    this.spinner.show();
    this.newPackageService.getFusoPackageCodeById(id).subscribe(
      result => {
        this.fusoPkgInfo = result;
        this.newPackageForm.patchValue({
          packageCode: this.fusoPkgInfo.response.fusoPackageCode,
          standardPackaging: this.fusoPkgInfo.response.standardPackaging,
          specializedPackaging: this.fusoPkgInfo.response.specializedPackaging,
          packagingName: this.fusoPkgInfo.response.packagingName,
          totalMaxWeightBox: this.fusoPkgInfo.response.totalMaxWeightBox,
          innerPackDimW: this.fusoPkgInfo.response.innerPackDimW,
          innerPackDimL: this.fusoPkgInfo.response.innerPackDimL,
          innerPackDimH: this.fusoPkgInfo.response.innerPackDimH,
          innerVolume: this.fusoPkgInfo.response.innerVolume,
          externalPackDimW: this.fusoPkgInfo.response.externalPackDimW,
          externalPackDimL: this.fusoPkgInfo.response.externalPackDimL,
          externalPackDimH: this.fusoPkgInfo.response.externalPackDimH,
          externalCubicMeter: this.fusoPkgInfo.response.externalCubicMeter,
          isFoldable: this.fusoPkgInfo.response.isFoldable,
          foldablePackDimW: this.fusoPkgInfo.response.foldablePackDimW,
          foldablePackDimL: this.fusoPkgInfo.response.foldablePackDimL,
          foldablePackDimH: this.fusoPkgInfo.response.foldablePackDimH,
          foldableVolume: this.fusoPkgInfo.response.foldableVolume,
          permittedLoadCapacity: this.fusoPkgInfo.response.permittedLoadCapacity,
          packageTareWeight: this.fusoPkgInfo.response.packageTareWeight,
          packageMaterial: this.fusoPkgInfo.response.packageMaterial,
          containerType: this.fusoPkgInfo.response.containerType
        });
        this.spinner.hide();
      })
  }

  canDeactivate() {
    if (this.newPackageForm.dirty && this.afterSaveNavigate == true) {
      return this.formDialogService.confirm();
    }
    return true
  }

  onContainerSelect(value) {
    console.log(this.loadCapacity);
    if (value == 'KLT') {
      this.newPackageForm.controls['permittedLoadCapacity'].clearValidators();
      this.newPackageForm.controls['permittedLoadCapacity'].setValidators(
        [Validators.required, Validators.maxLength(5), CustomValidators.isNum, Validators.max(15), CustomValidators.isNegative]);

    }
    else {
      this.newPackageForm.controls['permittedLoadCapacity'].clearValidators();
      this.newPackageForm.controls['permittedLoadCapacity'].setValidators(
        [Validators.required, Validators.maxLength(5), CustomValidators.isNum, CustomValidators.isNegative]);

    }
    this.newPackageForm.controls['permittedLoadCapacity'].updateValueAndValidity();



  }

  widthCompare() {
    this.widthGreater = false;
    let InnW = parseFloat(this.innerPackW)
    let ExtW = parseFloat(this.externalPackW)
    if (this.innerPackW != null && this.externalPackW != null) {
      if (InnW >= ExtW) {
        this.widthGreater = true;
      }
    }
  }

  lengthCompare() {
    this.lengthGreater = false;
    let InnL = parseFloat(this.innerPackL);
    let ExtL = parseFloat(this.externalPackL);
    if (this.innerPackL != null || this.innerPackL != undefined && this.externalPackL != null && this.externalPackL != undefined) {
      if (InnL >= ExtL) {
        this.lengthGreater = true;
      }
    }
  }

  heightCompare() {
    this.heightGreater = false;
    let InnH = parseFloat(this.innerPackH);
    let ExtH = parseFloat(this.externalPackH);
    if (this.innerPackH && this.externalPackH != null || this.innerPackH && this.externalPackH != undefined) {
      if (InnH >= ExtH) {
        this.heightGreater = true;
      }
    }
  }

  innerPackVol(): number {
    this.InnHeight = parseFloat(this.innerPackH);
    this.InnLength = parseFloat(this.innerPackL);
    this.InnWidth = parseFloat(this.innerPackW);

    if (this.innerPackH && this.innerPackL && this.innerPackW != null || this.innerPackH && this.innerPackL && this.innerPackW != undefined) {
      var InnerResult = (this.InnHeight * this.InnLength * this.InnWidth) / (1000 * 1000 * 1000);
      return InnerResult;
    }
  }

  externalVol(): number {
    this.ExtHeight = parseFloat(this.externalPackH);
    this.ExtLength = parseFloat(this.externalPackL);
    this.ExtWidth = parseFloat(this.externalPackW);
    if (this.externalPackH && this.externalPackL && this.externalPackW != null || this.externalPackH && this.externalPackL && this.externalPackW != undefined) {
      // var externalResult = (this.ExtHeight * this.ExtLength * this.ExtWidth) / (1000 * 1000 * 1000)
      this.externalResult = (this.ExtHeight * this.ExtLength * this.ExtWidth) / (1000 * 1000 * 1000)
      return this.externalResult;
    }
  }

  foldableVol(): number {
    if (this.foldableL && this.foldableH && this.foldableW != null || this.foldableW && this.foldableH && this.foldableL != undefined) {
      this.foldableResult = (this.foldableW * this.foldableL * this.foldableH) / (1000 * 1000 * 1000);
      return this.foldableResult
    }

  }

  folcheck() {
    if (this.folVol > this.extVol) {
      this.foldableGreater = true;
    }
  }

  totalBoxWeight(): number {
    if (this.loadCapacity && this.tareWeight != null) {
      let result = parseFloat(this.loadCapacity) + parseFloat(this.tareWeight)
      this.totalPackageWeight = result;
      return result;
    }
  }

  checkPackageCode(PackageCode) {
    if (this.packageId != null && this.packageId != '' && this.newPackageForm.get('packageCode').valid) {
      this.modalRef = this.modalService.open(PackageCode, { backdrop: false });
      this.modalRef.result.then((result) => {
      });
    }
  }
  onCancel() {
    this.newPackageForm.reset();
    // this.newPackageForm.controls['isFoldabe'].value = "'No'";
  }

  checkAvailiblity() {
    this.packageId = this.packageId.toUpperCase();
    if (this.userRoleID == 1 || (this.userRoleID == 2 && this.createdBySM == true) || (this.userRoleID == 7 && this.createdBySM == true)) {
      this.newPackageService.checkPackageCodeAvailiblity(this.packageId.trim()).subscribe(result => {
        this.checkPkgCode = result;
        this.pkgcodeCheck = this.checkPkgCode.response;
        if (this.pkgcodeCheck.hasOwnProperty('packageCode')) {
          this.translate.get('already exists. Please provide another Package Code').subscribe(res => {
            this.toaster.error(this.packageId + ' ' + res);
          })
          this.codeFlag = true;
        } else if (this.newPackageForm.get('packageCode').invalid) {
          this.toaster.error(this.translate.instant('Please enter a valid Package Code'));
        } else {

          this.translate.get('You can create New Supplier Package code request using').subscribe(res => {
            this.toaster.success(res + ' ' + this.packageId)
          });
          // this.toaster.success('You can use' + ' ' + this.packageId + ' ' + 'to create New Supplier Package code request');
          this.codeFlag = false;
        }
      });

    }
    else if (this.userRoleID != 1 || (this.userRoleID == 2 && this.createdBySM == false) || (this.userRoleID == 7 && this.createdBySM == false)) {
      this.newPackageService.getFusoPackageCodeById(this.packageId.trim()).subscribe(result => {
        this.chkFusoPkgCode = result;
        this.pkgcodeCheckFuso = this.chkFusoPkgCode.response;
        if (this.pkgcodeCheckFuso.hasOwnProperty('fusoPackageCode')) {
          this.toaster.error(this.packageId + ' ' + this.translate.instant('already exists. Please provide another Fuso Package Code'));
          this.codeFlag = true;
        } else if (this.newPackageForm.get('packageCode').invalid) {
          this.toaster.error(this.translate.instant('Please enter a valid Fuso Package Code'));
        } else {
          this.toaster.success('You can use' + ' ' + this.packageId + ' ' + 'to create Fuso Package code request');
          this.codeFlag = false;
        }
      });
    }
    this.modalRef.close();
  }

  foldableDisabled() {
    this.newPackageForm.controls['foldablePackDimW'].disable();
    this.newPackageForm.controls['foldablePackDimL'].disable();
    this.newPackageForm.controls['foldablePackDimH'].disable();
    this.newPackageForm.controls['foldablePackDimW'].reset();
    this.newPackageForm.controls['foldablePackDimL'].reset();
    this.newPackageForm.controls['foldablePackDimH'].reset();
    this.foldableGreater = false;
  }

  FoldableEnabled() {
    this.newPackageForm.controls['foldablePackDimW'].enable();
    this.newPackageForm.controls['foldablePackDimL'].enable();
    this.newPackageForm.controls['foldablePackDimH'].enable();
    this.foldableGreater = true;
  }

  foldableNotApplicable() {
    this.newPackageForm.controls['foldablePackDimW'].disable();
    this.newPackageForm.controls['foldablePackDimL'].disable();
    this.newPackageForm.controls['foldablePackDimH'].disable();
  }

  openCommentModal(addComment) {
    if (this.newPackageForm.valid && this.codeFlag == false && this.InnHeight < this.ExtHeight && this.InnLength < this.ExtLength
      && this.InnWidth < this.ExtWidth && (this.folVol < this.extVol || this.foldableGreater == false)) {
      this.modalRef = this.modalService.open(addComment, { backdrop: false });
      this.modalRef.result.then((result) => {
      });
    }
    else if (this.newPackageForm.invalid) {
      this.translate.get('Please fill all the required fields').subscribe(res => {
        this.toaster.warning(res)
      })
    }
    else if (this.codeFlag == true) {
      this.translate.get('Please change Package Code').subscribe(res => {
        this.toaster.error(res)
      })
    }

    else if (this.InnWidth >= this.ExtWidth) {
      this.translate.get('Please change Width dimension').subscribe(res => {
        this.translate.get('External package Width must be greater than Inner package Width!').subscribe(result => {
          this.toaster.error(result, res);
        })
      })
    }
    else if (this.InnLength >= this.ExtLength) {
      this.translate.get('Please change Length dimension').subscribe(res => {
        this.translate.get('External package Length must be greater than Inner package Length!').subscribe(result => {
          this.toaster.error(result, res);
        })
      })
    }
    else if (this.InnHeight >= this.ExtHeight) {
      this.translate.get('Please change Height dimension').subscribe(res => {
        this.translate.get('External package Height must be greater than Inner package Height!').subscribe(result => {
          this.toaster.error(result, res);
        })
      })
    }
    else if (this.folVol >= this.extVol) {
      this.translate.get('Please change Foldable Dimension').subscribe(res => {
        this.toaster.error(res);
      })
    }
  }
  openAdminCommentModal() {
    if (this.newPackageForm.valid && this.InnHeight < this.ExtHeight && this.InnLength < this.ExtLength
      && this.InnWidth < this.ExtWidth && (this.folVol < this.extVol || this.foldableGreater == false)) {
      // this.modalRef = this.modalService.open(addAdminComment, { backdrop: false });
      // // this.modalRef.result.then((result) => {
      // });
      this.addAdminComment = true
    }
    else if (this.newPackageForm.invalid) {
      this.translate.get('Please fill all the required fields').subscribe(res => {
        this.toaster.warning(res)
      })
    }
    else if (this.InnWidth >= this.ExtWidth) {
      this.translate.get('Please change Width dimension').subscribe(res => {
        this.translate.get('External package Width must be greater than Inner package Width!').subscribe(result => {
          this.toaster.error(result, res);
        })
      })
    }
    else if (this.InnLength >= this.ExtLength) {
      this.translate.get('Please change Length dimension').subscribe(res => {
        this.translate.get('External package Length must be greater than Inner package Length!').subscribe(result => {
          this.toaster.error(result, res);
        });
      });
    }
    else if (this.InnHeight >= this.ExtHeight) {
      this.translate.get('Please change Height dimension').subscribe(res => {
        this.translate.get('External package Height must be greater than Inner package Height!').subscribe(result => {
          this.toaster.error(result, res);
        })
      })
    }
    else if (this.folVol >= this.extVol) {
      this.translate.get('Please change Foldable Dimension').subscribe(res => {
        this.toaster.error(res);
      })
    }
  }

  onStatusChange(option) {
    this.statusOption = option;
    if (option == 2) {
      this.showStatusComment = true;
    } else if (option == 1) {
      this.showStatusComment = false;
    }
  };

  getAllApprovedPkgCode() {
    if (this.userRoleID == 1 || (this.userRoleID == 3 && this.openRequested == true)) {
      this.newPackageService.getApprovedPkgCode().subscribe(
        result => {
          this.approvedPkgLookup = result;
          this.packageLookup = this.approvedPkgLookup.response;
          // this.dtTrigger.next();
        });
    }
    else if (this.userRoleID != 1) {
      this.newPackageService.getFusoPkgCode().subscribe(
        result => {
          this.fusoPkgLookup = result;
          this.packageLookup = this.fusoPkgLookup.response;
          // this.dtTrigger.next();
        }
      )
    }
  }

  closeRef(pkgRequested) {
    this.modalRef.close();
    this.openModal.emit()
  }

  showDialog() {
    this.display = true;
  }

  showStatusDialog() {
    this.statusDisplay = true;
  }
  showAdminCommentDialogue() {
    this.adminCommentDialogue = true
  }
  closeLookup() {
    this.display = false;
    this.dataTableComponent.reset();
  }
  // foldableValueSelected(item){
  //   // this.model.options = item;
  //   if(item == 'Yes'){
  //     this.newPackageForm.controls['foldablePackDimW'].enable();
  //     this.newPackageForm.controls['foldablePackDimL'].enable();
  //     this.newPackageForm.controls['foldablePackDimH'].enable();
  //     this.foldableGreater = true;
  //   }
  //   else if(item == 'No'){
  //     this.newPackageForm.controls['foldablePackDimW'].disable();
  //     this.newPackageForm.controls['foldablePackDimL'].disable();
  //     this.newPackageForm.controls['foldablePackDimH'].disable();
  //     this.newPackageForm.controls['foldablePackDimW'].reset();
  //     this.newPackageForm.controls['foldablePackDimL'].reset();
  //     this.newPackageForm.controls['foldablePackDimH'].reset();
  //     this.foldableGreater = false;
  //   }
  //   else if( item == 'N/A'){
  //     this.newPackageForm.controls['foldablePackDimW'].disable();
  //     this.newPackageForm.controls['foldablePackDimL'].disable();
  //     this.newPackageForm.controls['foldablePackDimH'].disable();
  //     this.foldableGreater = false;
  //   }
  // }
}
